<template>
  <div>
    <kst-output print-mode field="ConvNumber" :data="details" :catalog="Catalog"/>
    <kst-output print-mode field="Date" :data="details" :catalog="Catalog"/>
    <kst-output print-mode field="WarehouseID" :data="details" :catalog="Catalog"/>
  </div>
</template>

<script>
import Catalog from "../StcvCatalog.js";

export default {
  props: {
    details: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>